module.exports = __webpack_public_path__ + "img/product-smoke-6.aa14d130.jpg";